<template>
  <header
    class="bg-surface-default-low border-static-default-low flex items-center border-b px-32 py-18"
  >
    <div class="divide-static-default-low flex items-center gap-8 divide-x-1">
      <Logo
        class="flex h-24 shrink-0 items-center"
        :disabled="!allowRedirection"
      />

      <slot />
    </div>
  </header>
</template>

<script setup lang="ts">
import Logo from './Logo.vue'

defineProps<{
  allowRedirection?: boolean
}>()
</script>
